import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import HomePage from './pages/HomePage';
import AlbumPage from './pages/AlbumPage';
import PhotoUploadPage from './pages/PhotoUploadPage';
import VideosPage from './pages/VideosPage';
import AdminSettingsPage from './pages/AdminSettingsPage';
import MediaViewPage from './pages/MediaViewPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-primary">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/videos" element={<VideosPage />} />
            <Route path="/admin" element={<AdminSettingsPage />} />
            <Route path="/album/:albumId" element={<AlbumPage />} />
            <Route path="/album/:albumId/upload" element={<PhotoUploadPage />} />
            <Route path="/album/:albumId/upload/:uploadKey" element={<PhotoUploadPage />} />
            <Route path="/album/:albumId/photo/:photoId" element={<MediaViewPage />} />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
